import { postData, putData } from "api/api";

export const createSkill = async ({ authToken, data }) => {
  return await postData(`skill/`, data, authToken);
};

export const updateSkill = async ({ authToken, id, data }) => {
  return await putData(`skill/${id}/`, data, authToken);
};
